module.exports = __webpack_public_path__ + "static/media/how-much-does-it-cost-to-live-in-bangkok.cc263486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-much-does-it-cost-to-live-in-bangkok.jpg
// module id = 70
// module chunks = 0